import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles";
import { Colors, FONT_WEIGHT } from "../../helpers/theme";
import LandingBg from "../../assets/images/landing_bg.png";
import NoiseBg from '../../assets/images/noise.png';

const drawerWidth = 300;
const HeaderStyle = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1, 0),
    fontFamily: theme.typography.fontFamily,
    borderBottom: `1px solid ${alpha(Colors.black, 0.1)}`,
    backgroundColor: "rgba(14, 42, 38, 0.2)",
    position: 'absolute',
    top: '0',
    "& a": {
      fontSize: theme.typography.subtitle1.fontSize,
      textDecoration: "none",
      color: Colors.black,
      fontWeight: FONT_WEIGHT.bold,
      marginRight: "28px",
      "&:last-child": {
        marginRight: "0",
        marginLeft: "5px",
        [theme.breakpoints.down("sm")]: {
          display: "block",
        },
      },
      "& .img-icon": {
        // admin header
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(0),
      },
      [theme.breakpoints.down("sm")]: {
        marginRight: "8px",
      },
    },
    "& .fs12": {
      fontSize: theme.typography.subtitle1.fontSize,
    },
    "& .notification-mobile": {
      [theme.breakpoints.up("xs")]: {
        //admin header
        width: "65%",
      },
    },
    "& .liveAlertLogo": {
      transition: "all 0.3s ease-in-out",
      borderRadius: "16px",
      height: "32px",
      width: "32px",
    },
    "& .liveAlertBtn": {
      transition: "all 0.3s ease-in-out",
      [theme.breakpoints.down("sm")]: {
        minWidth: "30%",
        margin: "auto",
        display: "block",
      },
    },
    "& .header-toolbar": {
      transition: "all 0.3s ease-in-out",
    },
    "& .cross-icon": {
      position: "absolute",
      right: "0",
      top: "0px",
      cursor: "pointer",
      fill: Colors.white,
    },

    "& .MuiContainer-fixed": {
      "@media (min-width: 600px)": {
        "max-width": 'unset'
      },
      "@media (min-width: 1280px)": {
        "max-width": "1193px"
      }
    }
  },
  headerRoot: {
    padding: theme.spacing(1, 0),
    fontFamily: theme.typography.fontFamily,
    borderBottom: `1px solid ${alpha(Colors.black, 0.1)}`,
    backgroundColor: Colors.white,
    "& a": {
      fontSize: theme.typography.subtitle1.fontSize,
      textDecoration: "none",
      color: Colors.black,
      fontWeight: FONT_WEIGHT.bold,
      marginRight: "28px",
      "&:last-child": {
        marginRight: "0",
        marginLeft: "5px",
        [theme.breakpoints.down("sm")]: {
          display: "block",
        },
      },
      "& .img-icon": {
        // admin header
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(0),
      },
      [theme.breakpoints.down("sm")]: {
        marginRight: "8px",
      },
    },
    "& .fs12": {
      fontSize: theme.typography.subtitle1.fontSize,
    },
    "& .notification-mobile": {
      [theme.breakpoints.up("xs")]: {
        //admin header
        width: "65%",
      },
    },
    "& .liveAlertLogo": {
      transition: "all 0.3s ease-in-out",
      borderRadius: "16px",
      height: "32px",
      width: "32px",
    },
    "& .liveAlertBtn": {
      transition: "all 0.3s ease-in-out",
      [theme.breakpoints.down("sm")]: {
        minWidth: "30%",
        margin: "auto",
        display: "block",
      },
    },
    "& .header-toolbar": {
      transition: "all 0.3s ease-in-out",
    },
    "& .cross-icon": {
      position: "absolute",
      right: "0",
      top: "0px",
      cursor: "pointer",
      fill: Colors.white,
    },

    "& .MuiContainer-fixed": {
      "@media (min-width: 600px)": {
        "max-width": 'unset'
      },
      "@media (min-width: 1280px)": {
        "max-width": "1193px"
      }
    }
  },
  floatConnectContainer:{
    width:"100%",
    backgroundColor:"rgba(249, 250, 251, 0.8)",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    height:"5rem",
    position:"fixed",
    left:0,
    bottom:0,
  },
  floatConnectBtn:{
    width:"94%",
    marginLeft:"3%",
    height:"3.125rem",
    fontSize:"8.75rem",
    boxShadow:"0px 4px 32.5px 0px rgba(9, 38, 35, 0.25)"
  },
  logo: {
    [theme.breakpoints.up("xs")]: {
      height:"26px",
      marginTop:"0.25rem"
    },
    flexGrow: 1,
    [theme.breakpoints.down("sm")]: {
      maxWidth: "112px",
      marginTop: ".5rem",
    },
  },
  grow: {
    flexGrow: 1,
  },
  headerbtns: {
    "& a": {
      marginRight: "5px",
    },
  },
  fs: {
    "& span": {
      [theme.breakpoints.up("xs")]: {
        //admin header
        fontSize: theme.typography.subtitle1.fontSize,
      },
    },
  },
  walletDetails:{
    border:"1px solid rgba(17, 48, 45, 0.08) !important",
  },
  timer: {
    transition: "all 0.3s ease-in-out", 
    background: `linear-gradient(101.47deg, #0DF0B0 -29.45%, #1AA0C1 70.76%)`,
    [theme.breakpoints.up("xs")]: {
      //above 1280px
      padding: theme.spacing(1, 0),
    },
    "& .timerwrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "380px",
      [theme.breakpoints.down("md")]: {
        width: "300px",
      },
      "& .liveAlertLogo": {
        height: "2.5rem",
        width: "2.5rem",
        transition: "all 0.3s ease-in-out",
        [theme.breakpoints.down("sm")]: {
          borderRadius: ".6rem",
          height: "1.6rem",
          width: "1.6rem",
          transition: "all 0.3s ease-in-out",
        },
      },

      "& h3": {
        fontSize: "1.2rem",
        transition: "all 0.3s ease-in-out",
        marginBottom: "0",
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down("xs")]: {
          fontSize: "0.9em",
        },
      },
    },
    "& .alert-btn": {
      [theme.breakpoints.down("sm")]: {
        marginLeft: theme.spacing(0),
      },
    },
  },
  sticky: {
    "& .liveAlertLogo": {
      borderRadius: "12px",
      height: "25px",
      width: "25px",
      transition: "all 0.3s ease-in-out",
    },
    "& h3": {
      fontSize: "1rem",
      transition: "all 0.3s ease-in-out",
    },
    "& .liveAlertBtn > span": {
      fontSize: "10px",
      transition: "all 0.3s ease-in-out",
    },
    "& .header-toolbar": {
      minHeight: "50px",
      transition: "all 0.3s ease-in-out",
    },
    "& .timerSticky": {
      transition: "all 0.3s ease-in-out",
      [theme.breakpoints.up("xs")]: {
        //above 1280px
        padding: theme.spacing(1, 0),
      },
    },
    "& .timerwrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "280px",
      [theme.breakpoints.down("md")]: {
        width: "280px",
      },
    },
  },
  header: {
    backgroundColor: "#0E2A2633",
    padding: "5px 0",
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    backgroundColor: Colors.white,
    width: drawerWidth,
    borderRadius: "0 15px 15px 0",

    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    "& .drawerwrapper": {
      padding: theme.spacing(6, 4, 3, 4),
    },
    "& .border-bottom": {
      borderBottom: `1px solid ${alpha(Colors.black, 0.1)}`,
      marginBottom: theme.spacing(3),
    },
    "& .mobilebtns": {
      "& .MuiButton-outlinedSizeSmall, & .MuiButton-containedSizeSmall": {
        minWidth: "162px",
        padding: "5px 15px",
        marginBottom: theme.spacing(3),
      },
    },
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  connectWallet: {
    height:"2.125rem",
    "&.MuiButton-label": {
      fontSize: "0.5rem",
    }
  },
  filledButton: {
    background: "#fff",
    color: "rgba(52, 55, 55, 1)",
    '&:hover': {
      background: "rgba(0, 0, 0, 0.87)",
      color: "#fff"
    },
  },
  mobile: {
    background: Colors.greenDark + " !important",
    color: '#fff',
  },
  containedButton: {
    color: '#fff',
    borderColor: "#fff",
    '&:hover': {
      background: "rgba(0, 0, 0, 0.87)",
    }
  },
  supportIcon: {
    width: "1.5rem",
    border:"1px solid rgba(17, 48, 45, 0.08) !important",
    borderRadius: "50%",
    padding: "5px",
    '&: hover': {
      backgroundColor: Colors.greySlate,
      color: Colors.white
    }
  }
}));

const HeroStyle = makeStyles((theme) => ({
  hero: {
    position: 'relative',
    backgroundImage: `url(${LandingBg})`,
    backgroundSize: "cover",
    padding: "150px 0 50px 0",
    minHeight: "60vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "&::before": {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundSize: 'cover',
      pointerEvents: 'none',
      mixBlendMode: 'color-burn', // This is your blend mode
      backgroundImage: `url(${NoiseBg})`,
    },
    [theme.breakpoints.down("md")]: {
      
      
    },
    "& h1": {
      marginBottom: theme.spacing(2),
      color: Colors.white,
    },
    "& .body1":{
      opacity:0.8,
      marginTop:"2rem"
    },
    "& a": {
      marginTop: "30px",
      display: "block",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "none",
      },
    },
    "& .MuiGrid-container": {
      // borderLeft: `1px solid ${alpha(theme.Colors.black,0.1)}`,
      // borderRight: `1px solid ${alpha(theme.Colors.black,0.1)}`,
      [theme.breakpoints.down("md")]: {
        borderLeft: "0",
        borderRight: "0",
      },
    },
    "& .MuiGrid-item": {
      paddingBottom: theme.spacing(4),
    },
    "& .borderleft": {
      borderLeft: `1px solid ${alpha(Colors.black, 0.1)}`,
      [theme.breakpoints.down("md")]: {
        borderLeft: "0",
      },
    },
  },
  primaryButton: {
    background: "#002f41 !important",
    color: '#fff',
    boxShadow: 'none',
    padding: "7px 21px",
    '&:hover': {
      border: '1px solid #fff',
    }
  },
  secondaryButton: {
    borderColor: 'transparent',
    background: 'rgba(4, 31, 39, 0.3)',
    color: '#fff',
    padding: "7px 21px",
    '&:hover': {
      border: '1px solid #fff',
    }
  }
}));

const CommunityStyle = makeStyles((theme) => ({
  community: {
    fontFamily: "Poppins",
    padding: theme.spacing(10),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(3, 0),
    },
    "& h2": {
      marginBottom: theme.spacing(12),
      marginLeft: "30px",
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        marginLeft: "0",
      },
      [theme.breakpoints.down("xs")]: {
        marginBottom: theme.spacing(4),
        "& br": {
          display: "none",
        },
      },
    },

    "& h3": {
      fontFamily: "Poppins",
      marginTop: theme.spacing(7.5),

      marginBottom: theme.spacing(4),
      fontWeight: "bolder",
      fontSize: "33px",
    },
    "& .body1": {
      fontFamily: "Poppins",
      color: "#11302D",
      textAlign: "center",
    },
    "& .borderleft": {
      borderLeft: `1px solid ${alpha(Colors.black, 0.1)}`,
      paddingLeft: "30px",
      [theme.breakpoints.down("md")]: {
        paddingLeft: "0",
        paddingBottom: "25px",
        marginBottom: "25px",
        borderLeft: "0",

        "&:last-child": {
          borderBottom: "0",
          paddingBottom: "0",
          marginBottom: "0",
        },
        "& p": {
          "& br": {
            display: "none",
          },
        },
      },
      [theme.breakpoints.down("sm")]: {
        borderBottom: `1px solid ${alpha(Colors.black, 0.1)}`,
      },
    },
  },
}));

const AllProjectStyle = makeStyles((theme) => ({
  projects: {
    width: "100%",
    backgroundSize: 'cover',
    background: "linear-gradient(106.46deg, #00232B -1.01%, #41A0AD 37.69%, #68C9B1 76.38%, #5EFFB1 115.08%)",
    position: 'relative',
    "&::before": {
      position: "absolute",
      content: '""',
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      backgroundSize: 'cover',
      pointerEvents: 'none',
      backgroundImage: `url(${NoiseBg})`,
    },
    padding: ".75rem 0 2rem 0",
    overflow: "hidden",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(4, 0),
    },
    "& .MuiButton-root": {
      // minWidth: '220px'
    },
    "& p": {
      margin: "16px 0 22px 0",
    },
    "& .MuiContainer-root": {
      position: "relative",
    },
    "& h2": {
      marginBottom: "60px",
    },
    "& .projectdesc": {
      [theme.breakpoints.down("md")]: {
        marginBottom: theme.spacing(4),
      },
    },
    "& .mobileview": {
      border: `1px solid ${alpha(Colors.white, 0.1)}`,
      borderRadius: "6px",
      boxShadow: `0px 7px 41px ${alpha(Colors.black, 0.04)}`,
      padding: "12px",
      backgroundColor: Colors.white,
      "& p": {
        margin: "0",
      },
      "& img": {
        marginRight: "12px",
      },
    },
    "& .MuiPaper-rounded": {
      "&::-webkit-scrollbar": {
        width: 10,
        marginLeft: "20px",
        borderRadius: "20px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: `none`,
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#ffffff69 ",

        outline: `none`,
      },
      borderRadius: "0",
      // height: "475px",
      // overflowY: "auto",
      overflowX: "hidden",
    },
    "& .table-header": {
      position: "sticky",
      top: 0,
    },
    "& .lessrecords": {
      // height: "400px",
      // overflow: "auto",
    },
    "& .MuiTableRow-root": {
      boxShadow: "none",
    },
    "& .MuiTableCell-head:first-child": {
      width: "150px",
    },
    "& .MuiTableCell-body:first-child": {
      width: "150px",
    },
    "& .MuiTableCell-body:nth-child(2)": {
      width: "150px",
    },
    "& .MuiTableCell-body:nth-child(3)": {
      width: "150px",
    },
    "& .MuiTableCell-head:nth-child(2)": {
      width: "150px",
    },
    "& .MuiTableCell-head:nth-child(3)": {
      width: "150px",
    },

    "& .MuiTableRow-root:nth-of-type(odd)": {
      backgroundColor: alpha(Colors.blackLight, 0.1),
    },
    "& .MuiTableRow-root:nth-of-type(even)": {
      backgroundColor: alpha(Colors.white, 0.5),
    },
  },
  relative: {
    position: "relative",
  },
}));

const SliderStyle = makeStyles((theme) => ({
  slider: {
    "& h2": {
      marginBottom: theme.spacing(2),
    },
    "& img": {
      marginTop: theme.spacing(2),
    },
    "& .slide-content": {
      padding: "90px 0 15px 0",
      position: "relative",
      
    },
  },
  activeDot:{
    backgroundColor:"#041F27",
    width:"30px",
    height:"30px",
    borderRadius:"50%",
    position:"absolute",
    top:'0.5rem',
    left:0
  },
  dot:{
    backgroundColor:"#041F27",
    opacity:"0.1",
    width:"1rem",
    height:"1rem",
    borderRadius:"50%",
    position:"absolute",
    top:"1rem",
    left:"0.5rem"
  },

  dashedLine:{
    height:"4.5rem",
    width:"1px",
    borderLeft:"1px dashed #041F27",
    opacity:"0.2",
    position:"absolute",
    top:"3rem",
    left:"1rem"
  },
  slideText:{
    fontSize:"18px",
    fontFamilt:"Aspekta regular",
    color:"#343737",
    opacity:"0.6",
    marginTop:".75rem",
  }
}));

const CtaStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundSize: 'cover',
    background: "linear-gradient(106.46deg, #00232B -1.01%, #41A0AD 37.69%, #68C9B1 76.38%, #5EFFB1 115.08%)",
    position: 'relative',
    "&::before": {
      position: "absolute",
      content: '""',
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      backgroundSize: 'cover',
      pointerEvents: 'none',
      backgroundImage: `url(${NoiseBg})`,
    },
  },
  ctawrapper: {
    margin: theme.spacing(10, 0),
    width: "100%",
    minHeight: "10vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Poppins, sans-serif",
    color: "#ffffff",
    "& .first-part": {},

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
    "& p": {
      color: alpha(Colors.white, 0.8),
      marginBottom: "12px",
    },
    "& h2": {
      marginBottom: theme.spacing(5),
      [theme.breakpoints.down("xs")]: {
        "& br": {
          display: "none",
        },
      },
    },
  },
}));

const FAQStyle = makeStyles(() => ({
  lockAccordion: {
    fontFamily: "Poppins, sans-serif",
    boxShadow: "none",
    border: "none",
  },
  lockAccordionSummary: {
    display: "flex",
    flexDirection: "row-reverse", /* ensure it is row */
    alignItems: "center",
  }
}));

const FooterStyle = makeStyles((theme) => ({
  footer: {
    zIndex: 1111,
    marginTop: "auto",
    paddingTop: "56px",
    backgroundColor: "#11302D",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "32px",
    },
    "& h6": {
      marginBottom: theme.spacing(2),
    },
    "& a": {
      display: "block",
      opacity: "0.8",
      fontWeight: FONT_WEIGHT.regular,
      marginBottom: "12px",
      "&:hover": {
        textDecoration: "none",
      },
    },
    "& .MuiInputLabel-root": {
      color: alpha(Colors.white, 0.8),
    },
    "& .MuiButton-label": {
      fontSize: "12px !important",
    },
  },
  widget4: {
    "& .MuiBox-root": {
      "& h6": {
        marginBottom: "0",
        fontWeight: "normal",
      },
      "& a": {
        fontWeight: "bold",
        color: Colors.white,
        opacity: "1",
      },
    },
  },
  socials: {
    "& a": {
      marginRight: theme.spacing(2),
      opacity: "1",
      [theme.breakpoints.down("md")]: {
        marginRight: "10px",
      },
    },
    "& img": {
      width: "20px",
    },
  },
  cssLabel: {
    color: alpha(Colors.white, 0.8),
  },

  cssOutlinedInput: {
    minWidth: "235px",
    marginBottom: theme.spacing(2),
    color: Colors.white,
    "&$cssFocused $notchedOutline": {
      borderColor: `${alpha(Colors.white, 0.1)} !important`,
    },
  },
  cssFocused: {
    color: alpha(Colors.white, 0.8),
  },
  notchedOutline: {
    borderColor: `${alpha(Colors.white, 0.1)} !important`,
  },
  copyright: {
    marginTop: "56px",
    padding: "10px 0",
    borderTop: `1px solid ${alpha(Colors.white, 0.1)}`,
    borderBottom: `1px solid ${alpha(Colors.white, 0.1)}`,
    "& p": {
      opacity: "0.8",
      fontWeight: FONT_WEIGHT.regular,
      fontSize: theme.typography.subtitle1.fontSize,
    },
    "& a": {
      display: "flex",
      justifyContent: "center",
      alignItem: "center",
      opacity: "1",
      marginBottom: "0px",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "32px",
    },

    "& .gains-footer": {
      position: "relative",
      "&:after": {
        content: `" "`,
        position: "absolute",
        width: "1px",
        height: "45%",
        background: Colors.white,
        opacity: "0.1",
        right: "0px",
        top: "7px",
        [theme.breakpoints.down("xs")]: {
          display: "none",
        },
      },
    },
  },
}));
export {
  HeaderStyle,
  HeroStyle,
  CommunityStyle,
  AllProjectStyle,
  SliderStyle,
  CtaStyle,
  FooterStyle,
  FAQStyle,
};
